import { render, staticRenderFns } from "./workWithEmployee.vue?vue&type=template&id=165cde2c"
import script from "./workWithEmployee.vue?vue&type=script&lang=js"
export * from "./workWithEmployee.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports